import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { Link, withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { tokenVerification } from "./Utils";
import "react-toastify/dist/ReactToastify.css";

class MedicationTimeOfDay extends Component {
    constructor() {
        super();
        this.state = {
            timeOfDayList: [],
            isLoading: true,
        }
    }
    componentDidMount() {
        this.fetchAllTimeOfDay();
    }

    fetchAllTimeOfDay = () => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/all-schedule-timeOfDay",
            method: 'GET',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                dayScheduleId: localStorage.getItem("dayScheduleId")
            },
            success: function (res) {
                if (res.success === true) {
                    var allTimeOfDay = res.result;
                    thisController.state.timeOfDayList = allTimeOfDay;
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }


    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Schedule DaysOfWeek has been added successfully</b>, {
            position: "top-center",

        });

    };

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Schedule DaysOfWeek has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyDataProcessing() {
        toast.warning("Hold on, your data is saving...", {
            position: "top-center",
            toastId: "notifyDataProcessing",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Reminder deleted successfully</b>, {
            position: "top-center",
        });
    }


    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no times added for the medication. </p>
        </div>
    );

    convertTo12HourFormat = (timeStr) => {
        const [hours, minutes] = timeStr.split(':');
        let period = 'AM';
        let hours12 = parseInt(hours, 10);

        if (hours12 > 12) {
            hours12 -= 12;
            period = 'PM';
        } else if (hours12 === 12) {
            period = 'PM';
        } else if (hours12 === 0) {
            hours12 = 12;
        }

        return `${hours12}:${minutes.padStart(2, '0')} ${period}`;
    }

    render() {

        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> Time Taken</b>,
                selector: (row) => (
                    <div>
                        <div
                            style={{
                                display:
                                    row.id == "" ? "none" : row.id != this.state.editedId
                                        ? "block"
                                        : "none",
                                        textAlign : "center"
                            }}
                            id="timeofday"
                        >
                            {row.timeOfDay !== "" ? this.convertTo12HourFormat(row.timeOfDay) : row.timeOfDay}
                        </div>
                    </div>
                ),
            },

        ];
        return (
            <div style={{ marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/scrollbar.css" />
                <link rel="stylesheet" href="assets/css/customDataTable.css" />


                <div className="row">
                    <div style={{ marginTop: '16px', marginLeft:"0.5vw" }}  >
                        <Link to="/projectmgmt/reports/days-of-week">
                            <img src="./assets/images/arrow.svg"
                                style={{ paddingRight: "30%", cursor: 'pointer' }}
                            />
                        </Link>
                    </div>
                    <div >
                        <h6 className="nav-item" style={{ marginTop: '17px', fontSize: "17px" }}>
                            {localStorage.getItem("medicationTitle")}</h6>

                    </div>
                </div>
                {this.state.isLoading && (
                    <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                        <p>Loading ...</p>
                    </div>
                )}
                {!this.state.isLoading && this.state.timeOfDayList.length === 0 && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>There are no times added for the medication. </p>
                    </div>
                )}
                {this.state.timeOfDayList.length > 0 && (<div style={{ marginTop: '3vh', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                    <DataTable
                        data={this.state.timeOfDayList}
                        columns={columns}
                        noDataComponent={<this.CustomNoDataComponent />}
                    />
                </div>)}
                <ToastContainer className="Toast-at-center"
                    closeOnClick
                    theme="dark"
                    autoClose={4000}
                />
            </div>
        )
    }
}

export default MedicationTimeOfDay;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/MedicationTimeOfDay.js